import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Down = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.0003 22.584C15.4883 22.584 14.9763 22.389 14.5863 21.999L4.29325 11.706C3.90225 11.315 3.90225 10.682 4.29325 10.292C4.68425 9.90201 5.31631 9.90201 5.70731 10.292L16.0003 20.585L26.2932 10.292C26.6842 9.90201 27.3163 9.90201 27.7073 10.292C28.0983 10.683 28.0983 11.316 27.7073 11.706L17.4143 21.999C17.0243 22.39 16.5123 22.584 16.0003 22.584Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Down
